function getPurchaseButtonState(state, labels) {
  if (state.submitting) {
    return { disabled: true, label: labels.adding };
  }

  if (!state.available) {
    return { disabled: true, label: labels.soldOut };
  }

  return { disabled: false, label: labels.add };
}

function getCartErrorMessage(result, labels) {
  const serverMessage = `${result?.description || ''} ${result?.message || ''}`.toLowerCase();
  if (serverMessage.includes('sold out') || serverMessage.includes('unavailable')) {
    return labels.soldOut;
  }

  return labels.generic;
}

if (typeof module !== 'undefined' && module.exports) {
  module.exports = { getPurchaseButtonState, getCartErrorMessage };
}

if (typeof window !== 'undefined') {
  window.LexiProductFormState = { getPurchaseButtonState, getCartErrorMessage };
}
